export const VENUE_UUID = "b876c451-502d-4c97-91a5-aac2e7467583"